var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncliPlate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5318 30.9582C31.0455 34.2255 27.535 36.4442 24.4652 36.809C20.6356 37.2497 10.4385 37.3257 6.65453 36.8546C3.93429 36.5202 1.36602 34.499 0.651772 31.8396C0.0135043 29.4689 0.0438978 15.5334 0.423819 12.7523C0.742953 10.488 3.05288 10.8831 3.05288 11.5974V30.5783C3.05288 31.6116 5.3628 33.724 6.45697 34.0127C8.61493 34.575 21.897 34.5142 24.4804 34.1647C26.0153 33.952 28.8875 32.1891 28.8875 30.5935V11.9773C28.8875 11.8557 29.7538 10.9743 30.1489 11.0807L31.547 11.9773V30.9582H31.5318Z",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2133 5.69882C32.2133 5.69882 32.2133 7.5 32.2133 8.35827C32.2133 8.35827 0.5 8 0.500187 8.37347C-0.336853 8.37347 0.13614 5.69882 0.135462 5.3341L23.3265 5.27331C25.0002 5.27331 23.4633 0 25.6517 0C28.2807 0.0151969 26.6546 5.69882 28.691 5.69882H32.2133Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncliPlate);
export default __webpack_public_path__ + "static/media/incli_plate.e92d39e08c58ec87bd0ae4fe47ba9cd7.svg";
export { ForwardRef as ReactComponent };